'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _text = require('@hixme-ui/text');

var _text2 = _interopRequireDefault(_text);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Percentage = function Percentage(_ref) {
  var children = _ref.children,
      hideDecimals = _ref.hideDecimals,
      value = _ref.value,
      props = (0, _objectWithoutProperties3.default)(_ref, ['children', 'hideDecimals', 'value']);
  return _react2.default.createElement(
    _text2.default,
    props,
    Percentage.format({
      children: children,
      hideDecimals: hideDecimals,
      value: value
    })
  );
};

Percentage.format = function () {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      value = _ref2.value,
      children = _ref2.children,
      hideDecimals = _ref2.hideDecimals;

  var property = value !== null && !isNaN(value) ? value : children;
  var displayValue = parseFloat(property);

  if (isNaN(displayValue)) {
    console.error(Percentage.huiName + ': Could not parse ' + property + ' as a percentage.');
    return '%';
  }

  displayValue *= 100;

  if (hideDecimals) {
    displayValue = displayValue.toFixed(0);
  } else {
    displayValue = displayValue.toFixed(2);
  }

  return displayValue + '%';
};

Percentage.propTypes = {
  children: _propTypes2.default.node,
  hideDecimals: _propTypes2.default.bool,
  value: _propTypes2.default.number
};

Percentage.defaultProps = {
  children: null,
  hideDecimals: false,
  value: null
};

Percentage.displayName = 'Percentage';
Percentage.huiName = 'hui:Percentage';

exports.default = Percentage;
//# sourceMappingURL=Percentage.js.map


//////////////////
// WEBPACK FOOTER
// ../percentage/lib/Percentage.js
// module id = 735
// module chunks = 0